// @flow
import { css } from 'styled-components';

export const LAYOUT_MAX_WIDTH = css`
  max-width: 35em; /* 560px */
`;

export const WRAPPER_MAX_WIDTH = css`
  max-width: 80em; /* 1280px */
`;



// WEBPACK FOOTER //
// ./src/styles/widths.js